(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stockist-locator"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const DEFAULT_CONFIG = {
      defaultCenter: [40.7128, -74.006],
      defaultZoom: 12,
      mapboxToken: 'pk.eyJ1IjoibWFyZ2luZ2xvYmFsIiwiYSI6ImNtazc3Z3A1ajEyaW8zY291NThlcnc1czAifQ.7MNjFR8shMk1WTp7z3Qn9w',
      geocodeUrl: 'https://nominatim.openstreetmap.org/search',
      debounceDelay: 300,
      minChars: 3,
      distanceOptions: [5, 10, 25, 50, 100, null],
      defaultDistance: null,
      distanceUnit: 'miles',
    };

    const CONFIG = { ...DEFAULT_CONFIG, ...(window.STOCKIST_CONFIG || {}) };
    const STOCKISTS = window.STOCKIST_DATA || [];

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 3959;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    function toRad(deg) {
      return deg * (Math.PI / 180);
    }

    function formatDistance(miles) {
      if (miles < 0.1) {
        return 'Nearby';
      } else if (miles < 1) {
        return `${(miles * 5280).toFixed(0)} ft`;
      } else {
        return `${miles.toFixed(1)} mi`;
      }
    }

    class StockistLocator {
      constructor(options = {}) {
        this.options = { ...CONFIG, ...options };
        this.map = null;
        this.markers = new Map();
        this.userMarker = null;
        this.userLocation = null;
        this.selectedStockist = null;
        this.allStockists = options.stockists || [...STOCKISTS];
        this.stockists = [...this.allStockists];
        this.highlightedIndex = -1;
        this.distanceFilter = this.options.defaultDistance;
        this.mapLoaded = false;

        this.init();
      }

      init() {
        this.cacheElements();
        this.createDistanceFilter();
        this.geocodeStockists().then(() => {
          this.loadMapbox().then(() => {
            this.initMap();
            this.renderStockists();
            this.addMarkers();
            this.bindEvents();
            this.fitMapToMarkers();
            this.restoreFromURL();
          });
        });
      }

      async loadMapbox() {
        if (window.mapboxgl) return Promise.resolve();

        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.href = 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.css';
          link.rel = 'stylesheet';
          document.head.appendChild(link);

          const script = document.createElement('script');
          script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      async geocodeStockists() {
        const geocodePromises = this.allStockists.map(async (stockist) => {
          if (stockist.lat && stockist.lng && stockist.lat !== 0 && stockist.lng !== 0) {
            return stockist;
          }

          const query = [stockist.address, stockist.city, stockist.country].filter(Boolean).join(', ');

          if (!query) return stockist;

          try {
            const params = new URLSearchParams({
              q: query,
              format: 'json',
              limit: 1,
            });

            const response = await fetch(`${CONFIG.geocodeUrl}?${params}`, {
              headers: { 'User-Agent': 'StockistLocator/1.0' },
            });

            if (response.ok) {
              const results = await response.json();
              if (results.length > 0) {
                stockist.lat = parseFloat(results[0].lat);
                stockist.lng = parseFloat(results[0].lon);
              }
            }
          } catch (error) {
            console.warn('Geocoding failed for:', stockist.name, error);
          }

          return stockist;
        });

        await Promise.all(geocodePromises);
        this.stockists = [...this.allStockists].filter((s) => s.lat && s.lng && s.lat !== 0);
      }

      restoreFromURL() {
        const params = new URLSearchParams(window.location.search);
        const lat = params.get('lat');
        const lng = params.get('lng');
        const address = params.get('address');
        const distance = params.get('distance');

        if (lat && lng) {
          if (address) {
            this.elements.input.value = address;
          }
          this.setUserLocation(parseFloat(lat), parseFloat(lng));
        }

        if (distance) {
          this.distanceFilter = distance === 'any' ? null : parseFloat(distance);
          if (this.elements.distanceFilter) {
            this.elements.distanceFilter.value = distance === 'any' ? '' : distance;
          }
          this.renderStockists();
          this.updateMarkers();
        }
      }

      updateURL() {
        const params = new URLSearchParams();

        if (this.userLocation) {
          params.set('lat', this.userLocation.lat.toFixed(6));
          params.set('lng', this.userLocation.lng.toFixed(6));

          const address = this.elements.input.value.trim();
          if (address) {
            params.set('address', address);
          }
        }

        if (this.distanceFilter !== null) {
          params.set('distance', this.distanceFilter);
        } else if (this.userLocation) {
          params.set('distance', 'any');
        }

        const newURL = params.toString()
          ? `${window.location.pathname}?${params.toString()}`
          : window.location.pathname;

        window.history.replaceState({}, '', newURL);
      }

      cacheElements() {
        const container = document.querySelector('stockist-locator');
        this.elements = {
          container: container,
          input: container.querySelector('#address-input'),
          searchBtn: container.querySelector('#search-btn'),
          clearBtn: container.querySelector('#clear-btn'),
          autocomplete: container.querySelector('#autocomplete-results'),
          list: container.querySelector('#stockist-list'),
          map: container.querySelector('#map'),
          geolocationBtn: container.querySelector('#geolocation-btn'),
          shareBtn: container.querySelector('#share-btn'),
          count: container.querySelector('#stockist-count'),
          distanceFilter: null,
        };
      }

      createDistanceFilter() {
        const filterHtml = `
        <div class="stockist-filters">
          <label for="distance-filter" class="filter-label">Show stores within:</label>
          <select id="distance-filter" class="filter-select">
            ${this.options.distanceOptions
              .map((d) =>
                d === null ? `<option value="">Any distance</option>` : `<option value="${d}">${d} miles</option>`
              )
              .join('')}
          </select>
        </div>
      `;

        const countEl = this.elements.count;
        if (countEl) {
          countEl.insertAdjacentHTML('afterend', filterHtml);
        }

        this.elements.distanceFilter = this.elements.container.querySelector('#distance-filter');
      }

      initMap() {
        mapboxgl.accessToken = this.options.mapboxToken || CONFIG.mapboxToken;

        const center = this.options.defaultCenter || CONFIG.defaultCenter;
        const zoom = this.options.defaultZoom || CONFIG.defaultZoom;

        this.baseColor = this.getBaseColor();

        this.map = new mapboxgl.Map({
          container: this.elements.map,
          center: [center[1], center[0]],
          zoom: zoom,
          style: 'mapbox://styles/mapbox/light-v11',
          attributionControl: true,
        });

        this.map.on('load', () => {
          this.mapLoaded = true;
          this.applyMonotoneStyle();
        });

        this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');
        this.activePopup = null;
      }

      getBaseColor() {
        const container = this.elements.container || document.documentElement;
        const computed = getComputedStyle(container);
        const baseColor = computed.getPropertyValue('--map-color').trim();
        return baseColor || '#666666';
      }

      hexToHSL(hex) {
        const normalized = hex.replace('#', '');
        const r = parseInt(normalized.substr(0, 2), 16) / 255;
        const g = parseInt(normalized.substr(2, 2), 16) / 255;
        const b = parseInt(normalized.substr(4, 2), 16) / 255;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const lightness = (max + min) / 2;

        if (max === min) {
          return { h: 0, s: 0, l: lightness * 100 };
        }

        const delta = max - min;
        const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

        let hue;
        if (max === r) {
          hue = ((g - b) / delta + (g < b ? 6 : 0)) / 6;
        } else if (max === g) {
          hue = ((b - r) / delta + 2) / 6;
        } else {
          hue = ((r - g) / delta + 4) / 6;
        }

        return { h: hue * 360, s: saturation * 100, l: lightness * 100 };
      }

      formatHSL(hue, saturation, lightness) {
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      }

      applyMonotoneStyle() {
        const { h: hue } = this.hexToHSL(this.baseColor);
        const saturation = 5;

        const palette = {
          background: this.formatHSL(hue, saturation, 96),
          backgroundAlt: this.formatHSL(hue, saturation, 92),
          water: this.formatHSL(hue, saturation, 88),
          building: this.formatHSL(hue, saturation, 90),
          roadMinor: this.formatHSL(hue, saturation, 100),
          roadMajor: this.formatHSL(hue, saturation, 98),
          roadHighway: this.formatHSL(hue, saturation, 85),
          border: this.formatHSL(hue, saturation, 75),
          textDark: this.formatHSL(hue, saturation, 35),
          textMid: this.formatHSL(hue, saturation, 50),
          textLight: this.formatHSL(hue, saturation, 65),
        };

        const layers = this.map.getStyle().layers;

        for (const layer of layers) {
          this.applyLayerStyle(layer, palette);
        }
      }

      applyLayerStyle(layer, palette) {
        const { id, type } = layer;

        const setPaint = (property, color) => {
          try {
            this.map.setPaintProperty(id, property, color);
          } catch {
            // Layer may not support this paint property
          }
        };

        if (id === 'background') {
          setPaint('background-color', palette.background);
          return;
        }

        if (id.includes('water')) {
          if (type === 'fill') {
            setPaint('fill-color', palette.water);
          } else if (type === 'line') {
            setPaint('line-color', palette.water);
          }
          return;
        }

        if (id.includes('land') || id.includes('park') || id.includes('grass')) {
          if (type === 'fill') {
            setPaint('fill-color', palette.backgroundAlt);
          }
          return;
        }

        if (id.includes('building')) {
          if (type === 'fill') {
            setPaint('fill-color', palette.building);
          } else if (type === 'line') {
            setPaint('line-color', palette.border);
          }
          return;
        }

        if (id.includes('road') || id.includes('street') || id.includes('tunnel') || id.includes('bridge')) {
          if (type === 'line') {
            const roadColor = this.getRoadColor(id, palette);
            setPaint('line-color', roadColor);
          }
          return;
        }

        if (id.includes('admin') || id.includes('boundary')) {
          if (type === 'line') {
            setPaint('line-color', palette.border);
          }
          return;
        }

        if (type === 'symbol') {
          this.applyLabelStyle(id, palette, setPaint);
        }
      }

      getRoadColor(layerId, palette) {
        if (layerId.includes('motorway') || layerId.includes('trunk')) {
          return palette.roadHighway;
        }
        if (layerId.includes('primary') || layerId.includes('secondary') || layerId.includes('tertiary')) {
          return palette.roadMajor;
        }
        return palette.roadMinor;
      }

      applyLabelStyle(layerId, palette, setPaint) {
        if (layerId.includes('place') || layerId.includes('poi')) {
          setPaint('text-color', palette.textDark);
          setPaint('text-halo-color', palette.background);
        } else if (layerId.includes('road')) {
          setPaint('text-color', palette.textMid);
          setPaint('text-halo-color', palette.roadMinor);
        } else {
          setPaint('text-color', palette.textLight);
          setPaint('text-halo-color', palette.background);
        }
      }

      renderStockists() {
        this.applyFilters();

        const html = this.stockists.map((stockist, index) => this.createStockistHTML(stockist, index + 1)).join('');
        this.elements.list.innerHTML = html || this.createEmptyStateHTML();
        this.updateStoreCount();
      }

      applyFilters() {
        let filtered = [...this.allStockists].filter((s) => s.lat && s.lng && s.lat !== 0);

        if (this.userLocation) {
          filtered.sort((a, b) => {
            const distA = calculateDistance(this.userLocation.lat, this.userLocation.lng, a.lat, a.lng);
            const distB = calculateDistance(this.userLocation.lat, this.userLocation.lng, b.lat, b.lng);
            return distA - distB;
          });

          if (this.distanceFilter !== null) {
            filtered = filtered.filter((stockist) => {
              const dist = calculateDistance(this.userLocation.lat, this.userLocation.lng, stockist.lat, stockist.lng);
              return dist <= this.distanceFilter;
            });
          }
        }

        this.stockists = filtered;
      }

      handleDistanceFilterChange(value) {
        this.distanceFilter = value === '' ? null : parseFloat(value);
        this.renderStockists();
        this.updateMarkers();

        if (this.stockists.length === 0 && this.userLocation && this.distanceFilter !== null) {
          this.showError(`No stores found within ${this.distanceFilter} miles. Try increasing the distance.`);
        }

        this.updateURL();
      }

      updateStoreCount() {
        if (!this.elements.count) return;
        const count = this.stockists.length;
        const total = this.allStockists.filter((s) => s.lat && s.lng && s.lat !== 0).length;
        if (this.userLocation) {
          const filterText = this.distanceFilter ? ` within ${this.distanceFilter} mi` : '';
          this.elements.count.textContent = `${count} of ${total} store${total !== 1 ? 's' : ''}${filterText}`;
        } else {
          this.elements.count.textContent = `${count} store${count !== 1 ? 's' : ''} available`;
        }
      }

      createStockistHTML(stockist, index) {
        const addressParts = [stockist.address, stockist.city, stockist.country].filter(Boolean);
        const fullAddress = addressParts.join(', ');
        const distance = this.userLocation
          ? formatDistance(calculateDistance(this.userLocation.lat, this.userLocation.lng, stockist.lat, stockist.lng))
          : '';

        const directionsUrl =
          stockist.mapUrl || `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(fullAddress)}`;

        return `
        <article class="stockist-item" data-id="${
          stockist.id
        }" role="button" tabindex="0" aria-label="Store ${index}: ${stockist.name}">
          <div class="stockist-item-header">
            <span class="stockist-item-number" aria-hidden="true">${index}</span>
            <h3 class="stockist-item-name">${this.escapeHTML(stockist.name)}</h3>
            ${distance ? `<span class="stockist-item-distance">${distance}</span>` : ''}
          </div>
          <p class="stockist-item-address">${this.escapeHTML(fullAddress)}</p>
          <div class="stockist-item-details">
            ${
              stockist.phone
                ? `<a href="tel:${stockist.phone}" class="stockist-item-link" aria-label="Call ${
                    stockist.name
                  }">${this.escapeHTML(stockist.phone)}</a>`
                : ''
            }
            ${
              stockist.url
                ? `<a href="${this.escapeHTML(
                    stockist.url
                  )}" class="stockist-item-link" target="_blank" rel="noopener" aria-label="Visit ${
                    stockist.name
                  } website">Website</a>`
                : ''
            }
            <a href="${directionsUrl}" class="stockist-item-link" target="_blank" rel="noopener" aria-label="Get directions to ${
          stockist.name
        }">Directions</a>
          </div>
        </article>
      `;
      }

      createEmptyStateHTML() {
        return `
        <div class="stockist-empty">
          <p>No stores found in this area.</p>
        </div>
      `;
      }

      escapeHTML(str) {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }

      addMarkers() {
        this.stockists.forEach((stockist, index) => {
          const marker = this.createMarker(stockist, index + 1);
          this.markers.set(stockist.id, marker);
        });
      }

      updateMarkers() {
        this.markers.forEach((marker) => marker.remove());
        this.markers.clear();
        this.addMarkers();
      }

      createMarker(stockist, number) {
        const el = document.createElement('div');
        el.className = 'stockist-marker';
        el.innerHTML = `<span class="stockist-marker-number">${number}</span>`;

        const marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
          .setLngLat([stockist.lng, stockist.lat])
          .addTo(this.map);

        marker._element = el;
        marker._stockistId = stockist.id;
        marker._stockist = stockist;

        el.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectStockist(stockist.id);
        });

        return marker;
      }

      showPopup(stockist) {
        if (this.activePopup) {
          this.activePopup.remove();
        }

        const addressParts = [stockist.address, stockist.city, stockist.country].filter(Boolean);
        const fullAddress = addressParts.join(', ');
        const popupHTML = `
        <div class="stockist-popup">
          <div class="stockist-popup-name">${this.escapeHTML(stockist.name)}</div>
          <div class="stockist-popup-address">${this.escapeHTML(fullAddress)}</div>
          ${
            stockist.url
              ? `<a href="${this.escapeHTML(
                  stockist.url
                )}" class="stockist-popup-link" target="_blank" rel="noopener">Visit Website</a>`
              : ''
          }
        </div>
      `;

        this.activePopup = new mapboxgl.Popup({
          closeButton: true,
          closeOnClick: false,
          offset: 20,
        })
          .setLngLat([stockist.lng, stockist.lat])
          .setHTML(popupHTML)
          .addTo(this.map);
      }

      fitMapToMarkers() {
        if (this.stockists.length === 0) return;

        const bounds = new mapboxgl.LngLatBounds();
        this.stockists.forEach((s) => bounds.extend([s.lng, s.lat]));

        this.map.fitBounds(bounds, {
          padding: 50,
          maxZoom: 15,
        });
      }

      async geocodeAddress(query) {
        try {
          const params = new URLSearchParams({
            q: query,
            format: 'json',
            limit: 5,
            addressdetails: 1,
          });

          const response = await fetch(`${CONFIG.geocodeUrl}?${params}`, {
            headers: {
              'User-Agent': 'StockistLocator/1.0',
            },
          });

          if (!response.ok) throw new Error('Geocoding failed');

          return await response.json();
        } catch (error) {
          console.error('Geocoding error:', error);
          return [];
        }
      }

      async handleSearch() {
        const query = this.elements.input.value.trim();
        if (!query) return;

        this.hideAutocomplete();
        this.showLoadingSkeletons();

        const results = await this.geocodeAddress(query);

        if (results.length > 0) {
          const location = results[0];
          this.setUserLocation(parseFloat(location.lat), parseFloat(location.lon));
        } else {
          this.showError('No locations found for that address. Please try a different search.');
          this.renderStockists();
        }
      }

      showLoadingSkeletons() {
        const skeletons = Array(3)
          .fill(null)
          .map(
            () => `
        <div class="stockist-skeleton">
          <div class="stockist-skeleton-line short"></div>
          <div class="stockist-skeleton-line medium"></div>
          <div class="stockist-skeleton-line"></div>
        </div>
      `
          )
          .join('');
        this.elements.list.innerHTML = skeletons;
      }

      showError(message) {
        const errorHtml = `
        <div class="stockist-error" role="alert">
          <span class="stockist-error-message">${this.escapeHTML(message)}</span>
          <button class="stockist-error-dismiss" aria-label="Dismiss error">×</button>
        </div>
      `;

        const existingError = this.elements.list.querySelector('.stockist-error');
        if (existingError) {
          existingError.remove();
        }
        this.elements.list.insertAdjacentHTML('afterbegin', errorHtml);

        const dismissBtn = this.elements.list.querySelector('.stockist-error-dismiss');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', () => {
            this.elements.list.querySelector('.stockist-error')?.remove();
          });
        }
      }

      setUserLocation(lat, lng) {
        this.userLocation = { lat, lng };

        if (this.userMarker) {
          this.userMarker.remove();
        }

        const el = document.createElement('div');
        el.className = 'stockist-user-marker';

        this.userMarker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
          .setLngLat([lng, lat])
          .addTo(this.map);

        this.renderStockists();
        this.updateMarkers();
        this.centerOnUserWithStockists();
        this.updateClearButton();
        this.updateURL();
      }

      handleClear() {
        this.elements.input.value = '';

        if (this.userMarker) {
          this.userMarker.remove();
          this.userMarker = null;
        }

        if (this.activePopup) {
          this.activePopup.remove();
          this.activePopup = null;
        }

        this.userLocation = null;

        this.distanceFilter = this.options.defaultDistance;
        if (this.elements.distanceFilter) {
          this.elements.distanceFilter.value = this.distanceFilter === null ? '' : this.distanceFilter;
        }

        this.renderStockists();
        this.updateMarkers();
        this.fitMapToMarkers();
        this.updateClearButton();
        this.selectedStockist = null;
        this.updateURL();
        this.elements.input.focus();
      }

      updateClearButton() {
        if (!this.elements.clearBtn) return;
        const hasValue = this.elements.input.value.trim() !== '' || this.userLocation;
        this.elements.clearBtn.hidden = !hasValue;

        if (this.elements.shareBtn) {
          this.elements.shareBtn.hidden = !this.userLocation;
        }
      }

      async handleShare() {
        const url = window.location.href;

        try {
          if (navigator.share) {
            await navigator.share({
              title: 'Store Locations',
              text: 'Check out these store locations near me',
              url: url,
            });
            return;
          }

          await navigator.clipboard.writeText(url);

          const btn = this.elements.shareBtn;
          const originalText = btn.innerHTML;
          btn.classList.add('copied');
          btn.textContent = 'Link copied!';

          setTimeout(() => {
            btn.classList.remove('copied');
            btn.innerHTML = originalText;
          }, 2000);
        } catch (error) {
          this.showError('Unable to share. Try copying the URL from your browser.');
        }
      }

      async handleGeolocation() {
        if (!navigator.geolocation) {
          this.showError('Geolocation is not supported by your browser.');
          return;
        }

        const btn = this.elements.geolocationBtn;
        const originalText = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Locating...';

        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 300000,
            });
          });

          const { latitude, longitude } = position.coords;
          this.elements.input.value = 'Current location';
          this.setUserLocation(latitude, longitude);
        } catch (error) {
          let message = 'Unable to get your location. Please try entering an address instead.';
          if (error.code === error.PERMISSION_DENIED) {
            message = 'Location access was denied. Please enable location permissions or enter an address.';
          } else if (error.code === error.TIMEOUT) {
            message = 'Location request timed out. Please try again or enter an address.';
          }
          this.showError(message);
        } finally {
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      }

      centerOnUserWithStockists() {
        if (!this.userLocation) return;

        const bounds = new mapboxgl.LngLatBounds();
        bounds.extend([this.userLocation.lng, this.userLocation.lat]);

        this.stockists.slice(0, 3).forEach((s) => {
          bounds.extend([s.lng, s.lat]);
        });

        this.map.fitBounds(bounds, {
          padding: 50,
          maxZoom: 15,
        });
      }

      async handleAutocomplete(query) {
        if (query.length < CONFIG.minChars) {
          this.hideAutocomplete();
          return;
        }

        const results = await this.geocodeAddress(query);
        this.showAutocomplete(results);
      }

      showAutocomplete(results) {
        if (results.length === 0) {
          this.hideAutocomplete();
          return;
        }

        const html = results
          .map(
            (result, index) => `
        <li class="autocomplete-item" data-index="${index}" data-lat="${result.lat}" data-lng="${result.lon}">
          ${this.escapeHTML(result.display_name)}
        </li>
      `
          )
          .join('');

        this.elements.autocomplete.innerHTML = html;
        this.elements.autocomplete.classList.add('active');
        this.elements.input.setAttribute('aria-expanded', 'true');
        this.highlightedIndex = -1;
      }

      hideAutocomplete() {
        this.elements.autocomplete.classList.remove('active');
        this.elements.autocomplete.innerHTML = '';
        this.elements.input.setAttribute('aria-expanded', 'false');
        this.highlightedIndex = -1;
      }

      selectAutocompleteItem(item) {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);

        this.elements.input.value = item.textContent.trim();
        this.hideAutocomplete();
        this.setUserLocation(lat, lng);
      }

      selectStockist(id) {
        if (this.selectedStockist !== null) {
          const prevItem = this.elements.list.querySelector(`[data-id="${this.selectedStockist}"]`);
          if (prevItem) prevItem.classList.remove('active');

          const prevMarker = this.markers.get(this.selectedStockist);
          if (prevMarker && prevMarker._element) {
            prevMarker._element.classList.remove('active');
          }
        }

        this.selectedStockist = id;

        const item = this.elements.list.querySelector(`[data-id="${id}"]`);
        if (item) {
          item.classList.add('active');
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        const marker = this.markers.get(id);
        if (marker) {
          if (marker._element) {
            marker._element.classList.add('active');
          }

          const stockist = this.stockists.find((s) => s.id === id);
          if (stockist) {
            this.showPopup(stockist);

            const currentZoom = this.map.getZoom();
            this.map.flyTo({
              center: [stockist.lng, stockist.lat],
              zoom: Math.max(currentZoom, 14),
              duration: 500,
            });
          }
        }
      }

      bindEvents() {
        this.elements.searchBtn.addEventListener('click', () => this.handleSearch());

        if (this.elements.clearBtn) {
          this.elements.clearBtn.addEventListener('click', () => this.handleClear());
        }

        if (this.elements.geolocationBtn) {
          this.elements.geolocationBtn.addEventListener('click', () => this.handleGeolocation());
        }

        if (this.elements.shareBtn) {
          this.elements.shareBtn.addEventListener('click', () => this.handleShare());
        }

        if (this.elements.distanceFilter) {
          this.elements.distanceFilter.addEventListener('change', (e) => {
            this.handleDistanceFilterChange(e.target.value);
          });
        }

        this.elements.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (this.highlightedIndex >= 0) {
              const items = this.elements.autocomplete.querySelectorAll('.autocomplete-item');
              if (items[this.highlightedIndex]) {
                this.selectAutocompleteItem(items[this.highlightedIndex]);
              }
            } else {
              this.handleSearch();
            }
          } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.navigateAutocomplete(e.key === 'ArrowDown' ? 1 : -1);
          } else if (e.key === 'Escape') {
            this.hideAutocomplete();
          }
        });

        const debouncedAutocomplete = debounce((query) => this.handleAutocomplete(query), CONFIG.debounceDelay);

        this.elements.input.addEventListener('input', (e) => {
          debouncedAutocomplete(e.target.value.trim());
          this.updateClearButton();
        });

        this.elements.autocomplete.addEventListener('click', (e) => {
          const item = e.target.closest('.autocomplete-item');
          if (item) {
            this.selectAutocompleteItem(item);
          }
        });

        this.elements.list.addEventListener('click', (e) => {
          const item = e.target.closest('.stockist-item');
          if (item && !e.target.closest('a')) {
            const id = parseInt(item.dataset.id, 10);
            this.selectStockist(id);
          }
        });

        this.elements.list.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            const item = e.target.closest('.stockist-item');
            if (item && !e.target.closest('a')) {
              e.preventDefault();
              const id = parseInt(item.dataset.id, 10);
              this.selectStockist(id);
            }
          }
        });

        document.addEventListener('click', (e) => {
          if (!this.elements.input.contains(e.target) && !this.elements.autocomplete.contains(e.target)) {
            this.hideAutocomplete();
          }
        });
      }

      navigateAutocomplete(direction) {
        const items = this.elements.autocomplete.querySelectorAll('.autocomplete-item');
        if (items.length === 0) return;

        if (this.highlightedIndex >= 0 && items[this.highlightedIndex]) {
          items[this.highlightedIndex].classList.remove('highlighted');
        }

        this.highlightedIndex += direction;
        if (this.highlightedIndex < 0) this.highlightedIndex = items.length - 1;
        if (this.highlightedIndex >= items.length) this.highlightedIndex = 0;

        items[this.highlightedIndex].classList.add('highlighted');
        items[this.highlightedIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new StockistLocator());
    } else {
      new StockistLocator();
    }

    window.StockistLocator = StockistLocator;
  })();
  } catch(e) { console.error(e); }
})();

})();
